export class CompanySearch {
  registeredCompanyName = '';
  address1 = '';
  address2 = '';
  city = '';
  state = '';
  zipCode = '';
  lookupTypeId = -1;
  lookupId= -1;
  entityNumber ='';
}
